import { createContext, useContext } from 'react';
import noop from 'utils/noop';
import { BaseAsset } from '../types';

export type AssetDetails<T> = Partial<T> & { isNewAsset?: boolean };

export interface BaseAssetManagerContextState<T> {
  assets: T[];
  assetTypeName: string | undefined;
  isModalOpen: boolean;
  isEditing: boolean;
  changesMade: boolean;
  selectedAssetId: number | string | undefined;
  assetDetails: AssetDetails<T>;
  assetErrors: any;
  onSearch: (searchText: string) => void;
  setIsModalOpen: (isOpen: boolean) => void;
  setIsEditing: (editing: boolean) => void; // These might be abstracted out even further into high level interaction functions
  setChangesMade: (changesMade: boolean) => void; // These might be abstracted out even further into high level interaction functions
  selectAssetInList: (selected: T) => void;
  handleClose: (onClose: () => void) => void;
  createNew: () => void;
  save: (transformToInput?: (assetDetails: AssetDetails<T>) => any) => void;
  cancel: () => void;
  deleteAsset: (id: string | number) => void;
  updateAssetDetails: (updated: AssetDetails<T>) => void; // These might be abstracted out even further into high level interaction functions
  updateAssetErrors: (errors: any) => void; // These might be abstracted out even further into high level interaction functions
}

export const BaseAssetManagerContext = createContext<BaseAssetManagerContextState<BaseAsset>>({
  assets: [],
  assetTypeName: undefined,
  isModalOpen: false,
  isEditing: false,
  changesMade: false,
  selectedAssetId: undefined,
  assetDetails: {},
  assetErrors: {},
  onSearch: noop,
  setIsModalOpen: noop,
  setIsEditing: noop,
  setChangesMade: noop,
  selectAssetInList: noop,
  handleClose: noop,
  createNew: noop,
  save: noop,
  deleteAsset: noop,
  cancel: noop,
  updateAssetDetails: noop,
  updateAssetErrors: noop,
});

export const useAssetManagerContext = () => useContext(BaseAssetManagerContext);
